export default __webpack_public_path__ + "static/media/nissan.b3a4476f.svg";